import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";

const useStyles = makeStyles(theme => ({
	mainContainer: {
		flex: 1,
		padding: theme.spacing(2),
		height: theme.replyPage ? "100%" : `calc(100% - 48px)`,
	},

	contentWrapper: {
		height: "100%",
		overflowY: "hidden",
		display: "flex",
		flexDirection: "column",
		...(theme.replyPage && {
			minHeight: 0,
			...(theme.replyDark ? theme.scrollbarStyles : {}),
			[theme.breakpoints.down("sm")]: { overflowY: "auto" },
		}),
	},
}));

const MainContainer = ({ children, onScroll }) => {
	const classes = useStyles();

	return (
		<Container className={classes.mainContainer}>
			<div className={classes.contentWrapper} onScroll={onScroll ? event => {
				if (event.target === event.currentTarget) onScroll(event);
			} : undefined}>{children}</div>
		</Container>
	);
};

export default MainContainer;
